import { ADMIN_DATA, } from '../action/types';

export default function adminReducer(state = localStorage.getItem('restaurantId'), action) {
  switch (action.type) {
      case ADMIN_DATA:
      return action.data;
      
    default:
      return state;
  }
}